import { cn, TIconButtonProps } from 'types';
import { Icon, IconType } from '../icons';

export const IconButton = (props: TIconButtonProps & { icon?: IconType }) => {
  const { disabled = false, width = 32, height = 32, className = '', iconClassName = '' } = props;

  return (
    <button
      id={props.id}
      className={cn(
        'cursor-pointer flex items-center gap-1 p-1',
        'disabled:bg-neutralGrey disabled:cursor-not-allowed',
        className
      )}
      disabled={disabled}
      onClick={props.onClick}
      aria-label={props.ariaLabel}
    >
      {props.icon && (
        <Icon className={iconClassName} fill={props.fill} icon={props.icon} height={height} width={width} />
      )}
      {props.label && <span className={cn(disabled && 'text-neutralPlus')}>{props.label}</span>}
    </button>
  );
};
